// Tenant permission copy: what a page says when an admin has set this user's
// permission for it to No on the Permissions screen. Not a plan limit, so it
// never offers an upgrade.

export const permissionsCopy = {
  noAccess: {
    reports: "Your administrator hasn't given you access to reports.",
  },
  howToChange: 'A tenant admin can change this on the Permissions screen.',
  // A page that belongs to a role (lib/roleGates), opened from a link or the address bar.
  roleGate: {
    admin: {
      title: 'This page is for your organisation’s admins.',
      body: 'Ask one of them if something here needs changing.',
    },
    platform: {
      title: 'This page is for Stratium staff.',
      body: 'It isn’t part of your organisation’s Cadence.',
    },
  },
} as const;
